import { z } from "zod";

export const RegisterUserDataSchema = z.object({
  lastName: z.string().min(1, { message: "姓は必須です" }).max(50, { message: "姓は50文字以下でなければなりません" }),
  firstName: z.string().min(1, { message: "名は必須です" }).max(50, { message: "名は50文字以下でなければなりません" }),
  companyName: z.string().min(1, { message: "企業名は必須です" }).max(100, { message: "企業名は100文字以下でなければなりません" }),
  departmentName: z.string().min(1, { message: "部署名は必須です" }).max(100, { message: "部署名は100文字以下でなければなりません" }),
  divisionName: z.string().max(100, { message: "部門名は100文字以下でなければなりません" }).optional(),
});

export type RegisterUserData = z.infer<typeof RegisterUserDataSchema>;
